import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnsubscribePageComponent } from './unsubscribe-page/unsubscribe-page.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./layout/layout.module').then(mod => mod.LayoutModule) },
  { path: 'unsubscribe', component: UnsubscribePageComponent,data: { title: 'StartupTN | Unsubscribe' }, }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    useHash: false,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
